module.exports = __webpack_public_path__ + "assets/img/sample.51a501e0.svg";